// dito ASK — Begleitfigur „Rund“ (Entwurf C, Entscheidung 13.10.2026) und Abzeichen (Sprint 4h).
// Reine SVG-Erzeugung per DOM (CSP: keine Inline-Styles, kein innerHTML). Farben über CSS-Klassen in participate.css:
// .cp-body/.cp-arm (Themenfarbe), .cp-skin (Hautton neutral hell), .cp-hair/.cp-ink (Logo-Farbe), .cp-cheek (Themenfarbe, transparent).
// Die Figur ist menschlich-neutral: kein Geschlecht, kein Alter, keine Kleidung mit Bedeutung. Sie erscheint nur auf der
// Start-, Meilenstein- und Dankesseite – nie neben Fragen (docs/MOTIVATION_DESIGN.md).

const NS = 'http://www.w3.org/2000/svg';

function el(name, attrs) {
  const e = document.createElementNS(NS, name);
  for (const [k, v] of Object.entries(attrs)) e.setAttribute(k, String(v));
  return e;
}

const HEAD = { cx: 65, cy: 58, r: 34 };
const HAIR = 'M31 54 q4 -30 34 -30 q30 0 34 30 q-14 -10 -34 -10 q-20 0 -34 10z';
const BODY = 'M24 165 q-6 -60 41 -70 q47 10 41 70z';

/**
 * Posen: Arme als dicke Striche in Körperfarbe (Hände als Kreise), Gesicht je Stimmung.
 *  wave   – winkt (Start, Meilenstein)       cheer – jubelt (Abschluss)
 *  point  – zeigt nach vorn (Vorschau)       nod   – ruhig, Arme unten (sachliche Profile)
 *  thumbs – Daumen hoch (Meilenstein formell) think – Hand am Kinn (Instruktion)
 */
const POSES = {
  wave:   { arms: [['M100 100 q22 -12 18 -40', 117, 58], ['M30 104 q-16 10 -10 34', 21, 140]], face: 'happy' },
  cheer:  { arms: [['M100 100 q22 -14 14 -46', 114, 52], ['M30 100 q-22 -14 -14 -46', 16, 52]], face: 'joy' },
  point:  { arms: [['M100 104 q20 2 26 -6', 126, 96], ['M30 104 q-16 10 -10 34', 21, 140]], face: 'happy' },
  nod:    { arms: [['M100 104 q14 12 10 32', 109, 138], ['M30 104 q-14 12 -10 32', 21, 138]], face: 'calm' },
  thumbs: { arms: [['M100 100 q24 -6 20 -30', 120, 68], ['M30 104 q-14 12 -10 32', 21, 138]], face: 'happy', thumb: [120, 68] },
  think:  { arms: [['M100 104 q-4 -2 -14 -12', 86, 92], ['M30 104 q-14 12 -10 32', 21, 138]], face: 'think' },
};

function face(g, kind) {
  if (kind === 'joy') {
    g.append(el('path', { d: 'M48 62 q5 -6 10 0', class: 'cp-mouth' }), el('path', { d: 'M72 62 q5 -6 10 0', class: 'cp-mouth' }), el('path', { d: 'M51 72 q14 14 28 0', class: 'cp-mouth' }));
  } else if (kind === 'think') {
    g.append(el('circle', { cx: 55, cy: 60, r: 4, class: 'cp-ink' }), el('circle', { cx: 79, cy: 60, r: 4, class: 'cp-ink' }),
      el('circle', { cx: 56.5, cy: 58.5, r: 1.3, class: 'cp-glint' }), el('circle', { cx: 80.5, cy: 58.5, r: 1.3, class: 'cp-glint' }),
      el('path', { d: 'M56 75 q9 3 18 0', class: 'cp-mouth' }));
  } else {
    g.append(el('circle', { cx: 53, cy: 62, r: 4, class: 'cp-ink' }), el('circle', { cx: 77, cy: 62, r: 4, class: 'cp-ink' }),
      el('circle', { cx: 54.5, cy: 60.5, r: 1.3, class: 'cp-glint' }), el('circle', { cx: 78.5, cy: 60.5, r: 1.3, class: 'cp-glint' }),
      el('path', { d: kind === 'calm' ? 'M55 74 q10 6 20 0' : 'M53 74 q12 10 24 0', class: 'cp-mouth' }));
  }
  g.append(el('circle', { cx: 43, cy: 72, r: 4, class: 'cp-cheek' }), el('circle', { cx: 87, cy: 72, r: 4, class: 'cp-cheek' }));
}

/** Begleitfigur als SVG (viewBox 0 0 140 175). pose: wave | cheer | point | nod | thumbs | think. */
export function companion(pose = 'wave', cls = 'companion') {
  const p = POSES[pose] || POSES.wave;
  const svg = el('svg', { viewBox: '0 0 140 175', class: cls, 'aria-hidden': 'true', focusable: 'false' });
  for (const [d] of p.arms) svg.append(el('path', { d, class: 'cp-arm' }));
  svg.append(el('path', { d: BODY, class: 'cp-body' }));
  for (const [, hx, hy] of p.arms) svg.append(el('circle', { cx: hx, cy: hy, r: 9, class: 'cp-skin' }));
  if (p.thumb) svg.append(el('rect', { x: p.thumb[0] - 2.5, y: p.thumb[1] - 18, width: 5, height: 11, rx: 2.5, class: 'cp-skin' }));
  svg.append(el('circle', { cx: HEAD.cx, cy: HEAD.cy, r: HEAD.r, class: 'cp-skin' }), el('path', { d: HAIR, class: 'cp-hair' }));
  face(svg, p.face);
  return svg;
}

// ---- Abzeichen --------------------------------------------------------------------------------------------------
// Familien je Zielgruppe (Entscheidung 13.10.2026): medal (Schüler:innen, Stern) · plaque (Lehrkräfte, Blatt) ·
// house (Eltern, Haus mit Herz) · shield (Sportler:innen, Pokal). Etappen-Abzeichen tragen die Nummer, das
// Abschluss-Abzeichen das Motiv. Zustände: done (gefüllt), active (Ring), todo (gestrichelt, grau).

const SHAPES = {
  medal:  'M32 4a28 28 0 1 0 0 56 28 28 0 0 0 0-56z',
  plaque: 'M32 5l24 14v26L32 59 8 45V19z',
  house:  'M6 20a14 14 0 0 1 14-14h24a14 14 0 0 1 14 14v24a14 14 0 0 1-14 14H20A14 14 0 0 1 6 44z',
  shield: 'M32 4l24 8v22q0 18-24 26Q8 52 8 34V12z',
};
const MOTIFS = {
  medal:  [['path', { d: 'M32 17l4.6 9.6 10.5 1.4-7.7 7.3 1.9 10.4-9.3-5.1-9.3 5.1 1.9-10.4-7.7-7.3 10.5-1.4z' }]],
  plaque: [['path', { d: 'M22 40q0-16 18-18-2 16-18 18z' }], ['path', { d: 'M24 39q6-8 14-14', class: 'bd-line' }]],
  house:  [['path', { d: 'M18 31l14-12 14 12v15H18z' }], ['path', { d: 'M32 42c-4-3-6-5.5-6-8a3 3 0 0 1 6-1 3 3 0 0 1 6 1c0 2.5-2 5-6 8z', class: 'bd-accent' }]],
  shield: [['path', { d: 'M23 17h18v9a9 9 0 0 1-18 0z' }], ['path', { d: 'M23 19h-4a4 4 0 0 0 0 8h4M41 19h4a4 4 0 0 1 0 8h-4', class: 'bd-line' }], ['rect', { x: 29.5, y: 35, width: 5, height: 5 }], ['rect', { x: 24, y: 40, width: 16, height: 4, rx: 1.2 }]],
};

/**
 * Abzeichen als SVG (viewBox 0 0 64 64). family: medal|plaque|house|shield; state: done|active|todo;
 * content: Zahl/Text (Etappe) oder 'motif' (Abschluss); extra: zusätzliche Klassen (z. B. 'badge--big').
 */
export function badge(family, state, content, extra = '') {
  const shape = SHAPES[family] || SHAPES.medal;
  const svg = el('svg', { viewBox: '0 0 64 64', class: `badge badge--${state} badge--${family}${extra ? ' ' + extra : ''}`, 'aria-hidden': 'true', focusable: 'false' });
  svg.append(el('path', { d: shape, class: 'bd-shape' }));
  if (family === 'medal' && state === 'done') svg.append(el('circle', { cx: 32, cy: 32, r: 22, class: 'bd-ring' }));
  if (content === 'motif') {
    for (const [name, attrs] of MOTIFS[family] || MOTIFS.medal) { const e = el(name, attrs); e.classList.add('bd-motif'); svg.append(e); }
  } else {
    const t = el('text', { x: 32, y: 39, 'text-anchor': 'middle', class: 'bd-text' });
    t.textContent = String(content);
    svg.append(t);
  }
  return svg;
}
